import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { BrandedLoader } from "@/components/layout/BrandedLoader";
import { OfflineScreen } from "@/components/layout/OfflineScreen";
import { useMe } from "@/features/auth/hooks";
import { isNetworkError } from "@/lib/api/network-error";

export function AuthGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { data, isLoading, isError, error, refetch } = useMe();

  // Vérification de session au démarrage : même écran que le splash.
  if (isLoading) return <BrandedLoader />;

  // Session connue — fraîche, ou restaurée depuis l'instantané de l'onglet :
  // on laisse entrer même si le rafraîchissement vient d'échouer. Le cookie JWT
  // reste valide côté serveur ; c'est le réseau qui manque, pas le droit
  // d'accès. Le bandeau hors ligne informe l'utilisateur.
  if (data) {
    return <>{children}</>;
  }

  // Serveur injoignable et rien en cache : ne PAS renvoyer vers /login, qui
  // exige justement le réseau et laisse croire à une déconnexion.
  if (isError && isNetworkError(error)) {
    return <OfflineScreen onRetry={() => void refetch()} />;
  }

  return <Navigate to="/login" replace state={{ from: location.pathname }} />;
}
